"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.wizardReviewerRoleSearchCandidatesOutputDtoSchema = exports.wizardReviewerRoleCandidateDtoSchema = exports.wizardReviewerRoleSearchCandidatesInputDtoSchema = exports.wizardReviewerRoleSetOutputDtoSchema = exports.wizardReviewerRoleSetInputDtoSchema = exports.wizardReviewerRoleListOutputDtoSchema = exports.wizardReviewerRoleHolderDtoSchema = exports.wizardReviewerRolePersonDtoSchema = void 0;
const z = __importStar(require("zod"));
const cadstrom_shared_1 = require("@cadstrom/cadstrom-shared");
exports.wizardReviewerRolePersonDtoSchema = z.object({
    userId: z.string(),
    username: z.string(),
    email: z.string().nullable(),
    displayName: z.string().nullable(),
});
exports.wizardReviewerRoleHolderDtoSchema = z.object({
    holder: exports.wizardReviewerRolePersonDtoSchema,
    role: cadstrom_shared_1.Auth.ReviewerRoleSchema,
    grantedBy: exports.wizardReviewerRolePersonDtoSchema.nullable(),
    grantedAt: z.string().datetime(),
});
exports.wizardReviewerRoleListOutputDtoSchema = z.object({
    holders: z.array(exports.wizardReviewerRoleHolderDtoSchema),
});
exports.wizardReviewerRoleSetInputDtoSchema = z.object({
    person: z.string().trim().min(1),
    role: cadstrom_shared_1.Auth.ReviewerRoleSchema.nullable(),
});
exports.wizardReviewerRoleSetOutputDtoSchema = z.object({
    userId: z.string(),
    role: cadstrom_shared_1.Auth.ReviewerRoleSchema.nullable(),
});
exports.wizardReviewerRoleSearchCandidatesInputDtoSchema = z.object({
    text: z.string().trim().min(1).max(200),
});
exports.wizardReviewerRoleCandidateDtoSchema = z.object({
    person: exports.wizardReviewerRolePersonDtoSchema,
    role: cadstrom_shared_1.Auth.ReviewerRoleSchema.nullable(),
});
exports.wizardReviewerRoleSearchCandidatesOutputDtoSchema = z.object({
    candidates: z.array(exports.wizardReviewerRoleCandidateDtoSchema),
});
//# sourceMappingURL=wizard-reviewer-role.dto.js.map